<p-toast></p-toast>
<div class="create-amenity">
  <form [formGroup]="amenityForm" (ngSubmit)="saveAmenity()">
    <div class="form-group">
      <label for="name">Amenity Name</label>
      <input id="name" type="text" formControlName="name" pInputText (blur)="checkAmenityName(amenityForm.get('name')?.value)"  />
      <div class="error" *ngIf="amenityForm.get('name')?.invalid && amenityForm.get('name')?.touched">
        <small class="m-0 text-danger">Amenity name is required.</small>
      </div>
      <div class="error" *ngIf="nameAlreadyExists">
        <small class="m-0 text-danger">This name already exists.</small>
      </div>
    </div>

    <div class="form-group">
      <label for="amenity_category_id">Amenity Category</label>
      <p-dropdown
        [options]="amenityCategories"
        optionLabel="name"
        optionValue="_id"
        formControlName="amenity_category_id"
        placeholder="Select a category"
        [showClear]="true"
        styleClass="w-100"
      ></p-dropdown>
    </div>

    <div class="form-group">
      <label for="description">Description</label>
      <textarea
        id="description"
        class="w-100"
        formControlName="description"
        rows="3"
        pInputTextarea
      ></textarea>
      <div class="error" *ngIf="amenityForm.get('description')?.invalid && amenityForm.get('description')?.touched">
        <small class="text-danger p-0">Description is required.</small>
      </div>
    </div>

    <div class="d-flex justify-content-end mt-3 p-1">
      <p-button
        type="submit"
        class="secondary-btn"
        [label]="isEdit ? 'Update' : 'Save'"
        [disabled]="amenityForm.invalid || nameAlreadyExists || !propertyIdForSave"
      ></p-button>
    </div>
  </form>
</div>
